import * as React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMale } from '@fortawesome/free-solid-svg-icons'

interface IPeople {
    normal: number,
    trans?: number
}

export default class People extends React.PureComponent<IPeople, {}> {
    public render() {
      const men = []
      for (let i = 0; i < this.props.normal; i++ ) {
          men.push(<FontAwesomeIcon className="m-1" icon={faMale}  size='2x' key={`${i.toString()}` }/>) 
      }
      if (this.props.trans) {
        for (let i = 0; i < this.props.trans; i++ ) {
            men.push(<FontAwesomeIcon className="opacity-50 m-1" size='2x' icon={faMale} key={`${i.toString()}t` }/>) 
        }
      }
      return (
          <div>
              {men}
          </div>
      );
    }
  }


// WEBPACK FOOTER //
// ./src/components/general/People.tsx